import styled from "@emotion/styled";
import type { StepLiquidityPool } from "@stepfinance/liquidity";
import type { FC } from "react";

export type PoolLabelsProps = {
  tokenNames: StepLiquidityPool["mintNames"];
  initialRowLabel: string;
};

export const PoolLabels: FC<PoolLabelsProps> = ({ tokenNames, initialRowLabel }) => (
  <PoolLabelColumn>
    <span>{initialRowLabel}</span>
    {tokenNames.map((name, index) => (
      <span key={`${name}-${index}`}>{name}</span>
    ))}
    <span>Pool Token Price</span>
    <span>Pool</span>
    <span>Curve Type</span>
  </PoolLabelColumn>
);

const PoolLabelColumn = styled.div`
  text-align: initial;

  span {
    color: #b2b2b2;
    font-size: 10px;
    line-height: 22px;
    display: block;
    margin-bottom: 10px;
  }
`;
